import { finalize, catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from './message.service';
import { ProgressBarService } from './progress-bar.service';

@Injectable()
export class ExcelExportService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/excel-export`;
  }

  private readonly _endpoint: string;

  getDynamicExcelExport(
    filter: any,
    context: string,
    fileName: string,
    selectedListViewColumns?: string[],
    includedIds?: string[],
    excludedIds?: string[],
    affectedItemsCount?: number
  ): Observable<File> {
    this._progressBar.start();

    const headers = { 'Content-Type': 'application/json' };

    const model = {
      filter: {
        context,
        fileName,
        selectedListViewColumns,
        typedFilter: filter,
      },
      includedIds,
      excludedIds,
      affectedItemsCount,
    };

    return this._client
      .post(`${this._endpoint}`, JSON.stringify(model), {
        headers,
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        map((res: HttpResponse<Blob>) => {
          return this.toFile(res, `${fileName}.xlsx`);
        }),
        catchError(error => {
          this._messageService.showError(error);
          return [];
        }),
        finalize(() => this._progressBar.stop())
      );
  }

  protected toFile(response: HttpResponse<Blob>, defaultName: string): File {
    const contentDisposition = response.headers.get('content-disposition') || '';
    const matches = /filename=([^;]+)/gi.exec(contentDisposition);
    const fileName = (matches ? matches[1].replace(/['"]+/g, '') : defaultName).trim();
    return new File([response.body], fileName, { type: response.body.type });
  }
}
